import { constants } from "@thecb/components";

export const themeValues = {
  BoxWithShadow: {
    linkColor: constants.colors.LUCKY_POINT,
  },
  Button: {
    activeBackgroundColor: {
      ghost: "transparent",
      primary: constants.colors.LUCKY_POINT_DARK,
      secondary: "rgb(190, 186, 214)",
      smallGhost: "transparent",
      tertiary: "transparent",
      whitePrimary: "rgb(229, 230, 231)",
    },
    activeBorderColor: {
      ghost: "transparent",
      primary: constants.colors.LUCKY_POINT_DARK,
      secondary: constants.colors.LUCKY_POINT,
      smallGhost: "transparent",
      tertiary: "transparent",
      whitePrimary: "2px solid rgb(229, 230, 231);",
    },
    activeColor: {
      ghost: constants.colors.LUCKY_POINT,
      primary: constants.colors.WHITE,
      secondary: constants.colors.LUCKY_POINT,
      smallGhost: constants.colors.LUCKY_POINT,
      tertiary: constants.colors.WHITE,
      whitePrimary: constants.colors.LUCKY_POINT,
    },
    backgroundColor: {
      ghost: "transparent",
      primary: constants.colors.LUCKY_POINT,
      secondary: "transparent",
      smallGhost: "transparent",
      tertiary: "transparent",
      whitePrimary: "transparent",
    },
    border: {
      ghost: "none",
      primary: `2px solid ${constants.colors.LUCKY_POINT};`,
      secondary: `2px solid  ${constants.colors.LUCKY_POINT};`,
      smallGhost: "none",
      tertiary: "none",
      whitePrimary: "2px solid transparent;",
    },
    color: {
      ghost: constants.colors.LUCKY_POINT,
      primary: constants.colors.WHITE,
      secondary: constants.colors.LUCKY_POINT,
      smallGhost: constants.colors.LUCKY_POINT,
      tertiary: constants.colors.LUCKY_POINT,
      whitePrimary: constants.colors.LUCKY_POINT,
    },
    height: {
      tertiary: "auto",
    },
    hoverBackgroundColor: {
      ghost: "transparent",
      primary: constants.colors.LUCKY_POINT_DARK,
      secondary: constants.colors.HAWKES_BLUE,
      smallGhost: "transparent",
      tertiary: "transparent",
      whitePrimary: "#F2F3F4",
    },
    hoverBorderColor: {
      ghost: "transparent",
      primary: constants.colors.LUCKY_POINT_DARK,
      secondary: constants.colors.LUCKY_POINT,
      smallGhost: "transparent",
      tertiary: "transparent",
      whitePrimary: "2px solid #F2F3F4;",
    },
    hoverColor: {
      ghost: constants.colors.LUCKY_POINT_DARK,
      primary: constants.colors.WHITE,
      secondary: constants.colors.LUCKY_POINT,
      smallGhost: constants.colors.LUCKY_POINT_DARK,
      tertiary: constants.colors.LUCKY_POINT_DARK,
      whitePrimary: constants.colors.LUCKY_POINT,
    },
  },
  Checkbox: {
    boxShadow: {
      default: "0 0 0 3px rgb(190, 186, 214);",
    },
    checkedStyles: {
      default: `background: ${constants.colors.LUCKY_POINT}; border: 1px solid ${constants.colors.LUCKY_POINT};`,
    },
  },
  Dropdown: {
    focusColor: constants.colors.LUCKY_POINT_DARK,
    hoverColor: constants.colors.HAWKES_BLUE,
    selectedColor: constants.colors.LUCKY_POINT,
  },
  FormInput: {
    hoverFocusStyles: {
      default: `outline: none; text-decoration: underline; color: ${constants.colors.LUCKY_POINT_DARK};`,
    },
    linkColor: {
      default: constants.colors.LUCKY_POINT,
    },
  },
  Icons: {
    accent: {
      error: "rgb(201, 197, 221)",
      info: "rgb(201, 197, 221)",
      success: "rgb(201, 197, 221)",
    },
    primaryColor: {
      error: constants.colors.LUCKY_POINT,
      info: constants.colors.LUCKY_POINT,
      success: constants.colors.LUCKY_POINT,
    },
    singleIconColor: {
      darkMode: constants.colors.LUCKY_POINT,
      primary: constants.colors.LUCKY_POINT,
      secondary: constants.colors.LUCKY_POINT_DARK,
    },
    subIconColor: {
      error: constants.colors.RAZZMATAZZ_RED,
      info: constants.colors.LUCKY_POINT,
      success: constants.colors.MEADOW_GREEN,
    },
  },
  MultipleSelectFilter: {
    primaryColor: constants.colors.WHITE,
    primaryHoverColor: constants.colors.HAWKES_BLUE,
    secondaryColor: constants.colors.LUCKY_POINT,
    secondaryHoverColor: constants.colors.LUCKY_POINT_DARK,
  },
  RadioButton: {
    activeColor: constants.colors.LUCKY_POINT,
  },
  Search: {
    searchIconColor: constants.colors.WHITE,
    searchIconBackgroundColor: constants.colors.LUCKY_POINT,
  },
  SolidDivider: {
    borderColor: {
      default: constants.colors.GHOST_GREY,
    },
  },
  Spinner: {
    color: constants.colors.LUCKY_POINT,
  },
  TableRow: {
    hoverBackgroundColor: constants.colors.HAWKES_BLUE,
    borderColor: constants.colors.GRECIAN_GREY,
  },
};
